import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/app/chat-interface/components/ChatLayout.tsx");
